import Marquee from "react-fast-marquee";

const ITEMS = [
  "Compassionate Recovery",
  "Evidence-Based Medicine",
  "Medication-Assisted Treatment",
  "Holistic Care",
  "Zero Judgement",
];

export const MarqueeStrip = () => (
  <section data-testid="marquee-strip" className="bg-accent border-y border-primary/10 py-6 md:py-8">
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="mx-10 md:mx-16 inline-flex items-center gap-10 md:gap-16 font-serif text-2xl md:text-4xl text-primary/90">
          {t}
          <span className="text-secondary text-lg">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
